<template>
  <div id="Declaration_config">
    <div class="hd_view">
      <div class="default_top">
        <div>
          <span>Health declarations</span>
        </div>
        <div>
          <button @click="declaration_config_preview()" class="main_btn">Preview</button>
        </div>
      </div>
      <div class="hd_block">
        <div class="hd_header">
          <div>
            <span class="title">Personally identifiable information</span>
          </div>
          <div>
            <b-form-checkbox name="check-button" switch v-model="hd_switch"></b-form-checkbox>
          </div>
        </div>
        <div class="hd_content">
          <div class="row">
            <div class="col-3">
              <span>Name</span>
            </div>
            <div class="col-9">
              <b-form-checkbox></b-form-checkbox>
            </div>
          </div>
          <div class="row">
            <div class="col-3">
              <span>Email</span>
            </div>
            <div class="col-9">
              <b-form-checkbox></b-form-checkbox>
            </div>
          </div>
          <div class="row">
            <div class="col-3">
              <span>Phone Number</span>
            </div>
            <div class="col-9">
              <b-form-checkbox></b-form-checkbox>
            </div>
          </div>
          <div class="row">
            <div class="col-3">
              <span>Id</span>
            </div>
            <div class="col-9">
              <b-form-checkbox></b-form-checkbox>
            </div>
          </div>
          <div class="row">
            <div class="col-3">
              <span>Mask id</span>
            </div>
            <div class="col-9">
              <b-form-checkbox></b-form-checkbox>
            </div>
          </div>
        </div>
      </div>

      <div class="hd_block">
        <div class="hd_header">
          <div>
            <span class="title">Visitor information</span>
          </div>
          <div>
            <b-form-checkbox v-model="hd_switch" name="check-button" switch></b-form-checkbox>
          </div>
        </div>
        <div class="hd_content">
          <div class="row">
            <div class="col-3">
              <span>Visitor Name</span>
            </div>
            <div class="col-9">
              <b-form-checkbox></b-form-checkbox>
            </div>
          </div>
          <div class="row">
            <div class="col-3">
              <span>Person to Meet</span>
            </div>
            <div class="col-9">
              <b-form-checkbox></b-form-checkbox>
            </div>
          </div>
          <div class="row">
            <div class="col-3">
              <span>Company</span>
            </div>
            <div class="col-9">
              <b-form-checkbox></b-form-checkbox>
            </div>
          </div>
          <div class="row">
            <div class="col-3">
              <span>Floor</span>
            </div>
            <div class="col-9">
              <b-form-checkbox></b-form-checkbox>
            </div>
          </div>
        </div>
      </div>

      <div class="hd_block">
        <div class="hd_header">
          <div>
            <span class="title">Symptoms</span>
          </div>
          <div>
            <b-form-checkbox name="check-button" switch v-model="hd_switch"></b-form-checkbox>
          </div>
        </div>
        <div class="hd_content">
          <div class="row">
            <div class="col-3">
              <span>Fever</span>
            </div>
            <div class="col-9 multiple_option">
              <div>
                <b-form-checkbox></b-form-checkbox>
              </div>
              <div>
                <span class="delete">
                  <span class="mdi mdi-trash-can"></span>
                </span>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-3">
              <span>Cough</span>
            </div>
            <div class="col-9 multiple_option">
              <div>
                <b-form-checkbox></b-form-checkbox>
              </div>
              <div>
                <span class="delete">
                  <span class="mdi mdi-trash-can"></span>
                </span>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-3">
              <span>Sore throat</span>
            </div>
            <div class="col-9 multiple_option">
              <div>
                <b-form-checkbox></b-form-checkbox>
              </div>
              <div>
                <span class="delete">
                  <span class="mdi mdi-trash-can"></span>
                </span>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <span class="span_anchor" @click="add_symptom()">
                <span class="mdi mdi-plus-thick"></span> add symptom
              </span>
            </div>
            <div class="col-6"></div>
          </div>
        </div>
      </div>

      <div class="hd_block">
        <div class="hd_header">
          <div>
            <span class="title">Travel Block List</span>
          </div>
          <div>
            <b-form-checkbox name="check-button" switch v-model="hd_switch"></b-form-checkbox>
          </div>
        </div>
        <div class="hd_content">
          <div class="country_wrap">
            <div class="row">
              <div class="col-3">
                <div class="country">
                  <span class="country_name">1. China</span>
                </div>
              </div>
              <div class="col-9">
                <span class="delete">
                  <span class="mdi mdi-trash-can"></span>
                </span>
                <span class="edit" @click="add_country()">
                  <span class="mdi mdi-pencil"></span>
                </span>
              </div>
            </div>
            <div class="row country_meta">
              <div class="col-12">
                <div>States : state 1, state 2, state 3</div>
                <div>Cities : city 1, city 2</div>
              </div>
            </div>
          </div>
          <div class="country_wrap">
            <div class="row">
              <div class="col-3">
                <div class="country">
                  <span class="country_name">2. Korea</span>
                </div>
              </div>
              <div class="col-9">
                <span class="delete">
                  <span class="mdi mdi-trash-can"></span>
                </span>
                <span class="edit" @click="add_country()">
                  <span class="mdi mdi-pencil"></span>
                </span>
              </div>
            </div>
            <div class="row country_meta">
              <div class="col-12">
                <div>States : state 1, state 2, state 3</div>
                <div>Cities : city 1, city 2</div>
              </div>
            </div>
          </div>
          <div class="country_wrap">
            <div class="row">
              <div class="col-3">
                <div class="country">
                  <span class="country_name">3. Iran</span>
                </div>
              </div>
              <div class="col-9">
                <span class="delete">
                  <span class="mdi mdi-trash-can"></span>
                </span>
                <span class="edit" @click="add_country()">
                  <span class="mdi mdi-pencil"></span>
                </span>
              </div>
            </div>
            <div class="row country_meta">
              <div class="col-12">
                <div>States : state 1, state 2, state 3</div>
                <div>Cities : city 1, city 2</div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <span class="span_anchor" @click="add_country()">
                <span class="mdi mdi-plus-thick"></span> add country
              </span>
            </div>
            <div class="col-6"></div>
          </div>
        </div>
      </div>

      <div class="hd_block">
        <div class="hd_header">
          <div>
            <span class="title">Quarantine</span>
          </div>
          <div>
            <b-form-checkbox name="check-button" switch v-model="hd_switch"></b-form-checkbox>
          </div>
        </div>
        <div class="hd_content">
          <div class="row">
            <div class="col-7">
              <span>
                Is any family member diagnosed with the virus or under
                quarantine
              </span>
            </div>
            <div class="col-5">
              <b-form-checkbox></b-form-checkbox>
            </div>
          </div>
          <div class="row">
            <div class="col-7">
              <span>
                Have you been served a government quarantine order or under self
                quanratine
              </span>
            </div>
            <div class="col-5">
              <b-form-checkbox></b-form-checkbox>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Add symptom -->
    <modal name="add_symptom" transition="pop-out" :width="600" height="auto">
      <addSymptom></addSymptom>
    </modal>
    <!-- Add country -->
    <modal name="add_country" transition="pop-out" :width="600" height="auto">
      <addCountry></addCountry>
    </modal>
    <!-- Declaration preview -->
    <modal
      name="declaration_config_preview"
      transition="pop-out"
      :width="720"
      height="auto"
      :scrollable="true"
    >
      <declarationConfigPreview></declarationConfigPreview>
    </modal>
  </div>
</template>

<script>
import addCountry from "../add_country/add_country.vue";
import addSymptom from "../add_symptom/add_symptom.vue";
import declarationConfigPreview from "../declaration_config_preview/declaration_config_preview.vue";

export default {
  name: "Declaration_config",
  components: {
    addSymptom,
    addCountry,
    declarationConfigPreview
  },
  data() {
    return {
      hd_switch: true
    };
  },
  methods: {
    add_country: function() {
      this.$modal.show("add_country");
    },
    add_symptom: function() {
      this.$modal.show("add_symptom");
    },
    declaration_config_preview: function() {
      this.$modal.show("declaration_config_preview");
    }
  }
};
</script>
